import { ITransferExamTypesDatasource } from './../datasources/transfer_exam_types_datasource';
import { ExamType } from './../builders/exam_type_builder';
import { Exam } from './../builders/exam_builder';
import { ITransferExamsDatasource } from './../datasources/transfer_exams_datasource';
import { IQueryMediator, IQuery } from 'core-ts-types';

export interface ITransferExamTypeWithExams {
  exam_type: ExamType;
  exams: Exam[];
}

export class TransferExamTypeWithExamsQuery implements IQuery {
  private _result: ITransferExamTypeWithExams[];

  constructor(
    QueryMediator: IQueryMediator,
    private ngTransferExamTypesDatasource: ITransferExamTypesDatasource,
    private ngTransferExamDatasource: ITransferExamsDatasource
  ) {
    QueryMediator.registerQuery(this, ngTransferExamTypesDatasource, this.ngTransferExamDatasource);
  }

  run(): TransferExamTypeWithExamsQuery {
    const exams = _.sortBy(this.ngTransferExamDatasource.read(), (exam) => exam.created_ts).reverse();
    const exam_types = _.sortBy(this.ngTransferExamTypesDatasource.read(), (exam_type) => [
      exam_type.ordering,
      exam_type.id
    ]);

    this._result = _.map(exam_types, (exam_type) => {
      return {
        exam_type: exam_type,
        exams: _.filter(exams, (exam) => exam.exam_type_code === exam_type.code)
      };
    });

    return this;
  }

  get result(): ITransferExamTypeWithExams[] {
    return this._result;
  }
}

angular.module('capability-ng-transfer').service('ngTransferExamTypeWithExamsQuery', TransferExamTypeWithExamsQuery);



// WEBPACK FOOTER //
// ./app/lib/transfer/queries/transfer_exam_type_with_exams_query.ts